import { TFunction } from "@/types";
import { IHousingListResponse, OfferType, OfferTypeObject } from "@/types";

export const getOfferTypes = (
  data: IHousingListResponse,
  t: TFunction,
  offerTypeList?: OfferTypeObject[],
) => {
  if (
    offerTypeList?.length === 2 &&
    offerTypeList[0].count === data.filterData.offerTypSellTotalCount &&
    offerTypeList[1].count === data.filterData.offerTypRentTotalCount
  ) {
    return offerTypeList;
  }
  return [
    { code: OfferType.SELL, title: t("sell"), count: data.filterData.offerTypSellTotalCount },
    { code: OfferType.RENT, title: t("rent"), count: data.filterData.offerTypRentTotalCount },
  ];
};
